import i18n from './i18n.setup.js';
import en from './en.js';
import ja from './ja.js';
i18n.translations["en"] = i18n.extend((i18n.translations["en"] || {}), en);
i18n.translations["ja"] = i18n.extend((i18n.translations["ja"] || {}), ja);
export const I18n = i18n;
